import log from '../../../utils/ClientLogger';
import { EMAIL_DUP_ERROR_MESSAGE, EMAIL_DUP_PUPS_ERROR_MESSAGE, PHONE_VALIDATION_ERROR_MESSAGE } from '../../../constants/common';
import { createOutcomeEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import { ELIGIBILITY_REJECT } from '../../../utils/SalesForceUtil';
import reasons from '../../../components/ListYourPropertyPage/EligibilityCatch/reasons';
import { CL_PROPERTY_INFO, LOCATION_PAGE } from '../../../components/PageFlow/PageList';

const PROPERTY_NAME_ERROR_MESSAGES = ['PropertyName is missing', 'PropertyName is invalid', 'UnicodePropertyName is invalid'];
const ADDRESS_ERROR_MESSAGES = ['Address is invalid'];

const isPropertyNameError = (message) => PROPERTY_NAME_ERROR_MESSAGES.includes(message);
const isAddressError = (message) => ADDRESS_ERROR_MESSAGES.includes(message);

const onError = (props) => (error) => {
    const {
        onSubmitError,
        setCreateAccountFail,
        pageFlow,
        // add trigger in parent props
        trigger
    } = props;

    let logLevel = 'error';
    let logEvent = 'LeadFormSubmit-Error';

    switch (error.message) {
    case EMAIL_DUP_PUPS_ERROR_MESSAGE:
    case EMAIL_DUP_ERROR_MESSAGE:
    case PHONE_VALIDATION_ERROR_MESSAGE:
        logLevel = 'info';
        logEvent = 'LeadFormSubmit-Info';
        break;
    default:
        break;
    }
    log(logLevel, logEvent, {
        message: error.message
    });
    trigger('outcome', createOutcomeEvent('user_account_creation.failed', 'LeadCapture', 'CreateAccount'));
    setCreateAccountFail(error.message);
    onSubmitError(error.message);

    if (isPropertyNameError(error.message)) {
        // User reached join-creation without a valid property name; send them back to fix it.
        pageFlow.navigate(CL_PROPERTY_INFO);
    } else if (isAddressError(error.message)) {
        // User reached join-creation without a valid address (e.g. page refresh); send them back.
        pageFlow.navigate(LOCATION_PAGE);
    }
};

const onComplete = (props) => ({ data }) => {
    const {
        address,
        latLngDetails,
        pageFlow,
        // functions
        setUserId,
        setCreateAccountSuccess,
        setEligibilityStatus,
        setJoinId,
        setPropertyId,
        // add trigger in parent props
        trigger,
        clearCompetitorUrl,
        clearSubmarketId,
        clearIsSelfServe,
        pageName
    } = props;
    const {
        type: contactType, lpsContact, rejectedReason
    } = data.createContact;
    clearSubmarketId();
    clearIsSelfServe();
    switch (contactType) {
    case ELIGIBILITY_REJECT:
        setEligibilityStatus(rejectedReason);
        pageFlow.next(pageName);
        break;
    case 'HOTELIER':
        setJoinId(lpsContact.joinId);
        setPropertyId(lpsContact.propertyId);
        setUserId(lpsContact.userId);
        if (!lpsContact.propertyId) {
            setEligibilityStatus(reasons.TIMEOUT_JEL);
        }
        clearCompetitorUrl();
        trigger('pageLoadGtm', {
            pageName: 'Success',
            event: 'SuccessLoad',
            ApplicationID: lpsContact.joinId
        });
        trigger('outcome', createOutcomeEvent('user_account_creation.succeeded', 'LeadCapture', lpsContact.joinId, '1.3.0', {
            event: {
                action_reason: latLngDetails.fuzzy ? 'fuzzy' : 'nonfuzzy',
                // eslint-disable-next-line eqeqeq
                action_location: `${latLngDetails.longitude == 0 ? '0/0' : 'latlng'} | ${address.country}`
            }
        }));
        pageFlow.next(pageName);
        break;
    default:
        throw new Error(`Unknown contactType '${contactType}' returned by service`);
    }
    setCreateAccountSuccess();
};
export default {
    onError,
    onComplete
};
